import { useState } from 'react';
import type { AttributeDistributionType } from 'types/api/diagnosisReportRefResponseType';
import {
  type AttributeKey,
  computeDisplay,
  getAttributeData,
} from './wsReportAttributeDistribution.utils';

export interface UseWsReportAttributeDistributionResult {
  selectedAttribute: AttributeKey;
  onSelectAttribute: (key: AttributeKey) => void;
  displayData: { label: string; count: number }[];
  displayTotalCount: number;
  maxCount: number;
}

/**
 * 属性分布の選択状態と派生データを管理するカスタムフック。
 */
export function useWsReportAttributeDistribution(
  attributeDistribution: AttributeDistributionType
): UseWsReportAttributeDistributionResult {
  const [selectedAttribute, setSelectedAttribute] = useState<AttributeKey>('gender');

  const onSelectAttribute = (key: AttributeKey): void => {
    setSelectedAttribute(key);
  };

  const currentData = getAttributeData(attributeDistribution, selectedAttribute);
  const { displayData, displayTotalCount, maxCount } = computeDisplay(
    currentData,
    selectedAttribute
  );

  return {
    selectedAttribute,
    onSelectAttribute,
    displayData,
    displayTotalCount,
    maxCount,
  };
}
